import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { SyncSourceObjectPage } from "./-syncs/sync-ops.pages";

export const Route = createFileRoute("/_dashboard/$datasetSlug/apps/syncs/$sourceId/$sourceObjectId")({
  component: SyncSourceObjectPage,
  validateSearch: z.object({
    record: z
      .string()
      .trim()
      .transform((value) => value || undefined)
      .optional()
      .catch(undefined),
    stage: z.enum(["extraction", "promotion"]).optional().catch(undefined),
    decision: z.enum(["seen", "imported", "skipped", "failed", "replayed", "promoted"]).optional().catch(undefined),
    failureGroup: z
      .string()
      .regex(/^v1_[A-Za-z0-9_-]{16}$/)
      .optional()
      .catch(undefined),
  }),
});
